import { render, staticRenderFns } from "./instFimollCareBox.vue?vue&type=template&id=62d48f51"
import script from "./instFimollCareBox.vue?vue&type=script&lang=js"
export * from "./instFimollCareBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports